import { useMutation } from 'react-query';
import { PlaceholderSettingDto } from '../../../../../../codegen/SwaggerProduct';
import { getProductReservationApi } from '../../../../../../config/SwaggerProductReservationApi';

const updatePlaceholderManagement = (project: PlaceholderSettingDto) =>
    getProductReservationApi()
        .placeholderSetting.updateUpdate(project)
        .then((response) => response.data);

const useUpdatePlaceholderManagement = () => {
    const useUpdatePlaceholderManagementMutation = useMutation(updatePlaceholderManagement);

    return useUpdatePlaceholderManagementMutation;
};

export default useUpdatePlaceholderManagement;
